import { useLocation, Link } from "react-router-dom";

function Failed() {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const orderId = params.get("order_id");

  return (
    <div className="container mt100 mb100">
      <div className="card w-75 m-auto p-5 text-center">
        
        <div style={{ fontSize: "80px" }}>
          ❌
        </div>

        <h2 className="mt-3 mb-4 text-danger">
          付款失敗
        </h2>

        <p className="fs-5">
          很抱歉，您的信用卡交易未完成。
        </p>

        {orderId && (
          <p className="text-muted">
            訂單編號：#{orderId}
          </p>
        )}

        <div className="mt-4">
          如有任何問題，請聯繫 Becker Taiwan 客服協助。
        </div>

        <div className="d-flex justify-content-center gap-3 mt-5">
          
          <Link
            to="/registration/plan"
            className="btn btn-outline-secondary"
          >
            返回方案頁
          </Link>

          <Link
            to="/"
            className="btn btn-primary"
          >
            回首頁
          </Link>

        </div>
      </div>
    </div>
  );
}

export default Failed;